import {
  DeleteOutlined
} from "@ant-design/icons";
import {
  Col,
  Form,
  Layout,
  Popconfirm,
  Row,
  Spin,Breadcrumb
} from "antd";
import "antd/dist/antd.min.css";
import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate,Link } from "react-router-dom";
import { getRequest, postRequest } from "../../axios";
import companyimg from "../../image/userimg.png";
import "../../styles/Main.scss";
import { authUserData } from "../../utils/Helper";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
const { Content } = Layout;
const ArchivedSuperUserList = () => {
  const navigate = useNavigate();
  const [arrow, setArrow] = useState("Show");
  const userId = authUserData()?.user_id ? authUserData()?.user_id : null;

  const mergedArrow = useMemo(() => {
    if (arrow === "Hide") {
      return false;
    }
    if (arrow === "Show") {
      return true;
    }
    return {
      pointAtCenter: true,
    };
  }, [arrow]);
  const colors = ["#094E8F"];
  const { t } = useTranslation();
  const CompanyId = authUserData()?.company ? authUserData()?.company : null;
  const [loading, setLoading] = useState(false);
  const [reload, setReload] = useState(false);
  const [totalCount, settotalCount] = useState(0);
  const [manageUserStep, setArchivedEmployeeList] = useState([]);
  const [state, setState] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10,
    search: "",
    total: 0,
  });
  // Sets the loading state while fetching data and sorts the data by employee ID.
  useEffect(() => {
    const getEmployeeArchiveList = async () => {
      setLoading(true);
      try {
        let apiResponse = await getRequest(`employee-archive/get-archive-company-employees`, state);
        if (apiResponse.data.results.success) {

          const sortedData = apiResponse.data.results.data.sort((a, b) => {
            return a.id - b.id;
          });

          setArchivedEmployeeList(sortedData);
          settotalCount(apiResponse.data.count);
        } else {
          ErrorNotificationMsg(t("error_in_archive_list"));
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    getEmployeeArchiveList();
  }, [state, reload, t]);

  // Updates the subscription status and saves the updated data to local storage.
  const updateSubscriptionStatus = async () => {
    const response = await getRequest(`user-detail/${userId}`);

    localStorage.setItem("auth_data", JSON.stringify(response.data.data));
  };

  // Handles form submission by updating subscription status and navigating to a different page.
  const handleSubmit = () => {
    updateSubscriptionStatus();
    navigate("/pr-release-hierarchy-step")
  }

// Restores an employee from the archive based on the provided ID.
  const handleRestore = async (id) => {
    try {
      let apiResponse = await postRequest("employee-archive/", {
        deleted: [id], // Send the ID in an array as expected by your API
      });
      if (apiResponse.data.success) {
        SuccessNotificationMsg(t("employee_restore_successfully"));
        setReload(!reload); // Trigger reload of employee list
        navigate("/superuser"); // Navigate to the employee list page after restore
      } else {
        ErrorNotificationMsg(t("error_in_restore_employee"));
      }
    } catch (error) {
      ErrorNotificationMsg(error);
    }
  };
  
  return (
    <>
     <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
          <h3>Archived Manage User</h3>

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>Archived Manage User</Breadcrumb.Item>
            </Breadcrumb>
          </div>
      
        </div>
      </div>
          <Content className="stepscontentwrap">
           
         
            <div className="stepsContent">

              <Spin spinning={loading}>
                <div className="cardswraper">
                  <Row gutter={24}>
                    {manageUserStep.map((user) => (
                      <Col xs={24} sm={24} md={12} xl={8} xxl={6} key={user.id}>
                        <div className="stepcard sitecard">
                          <div className="cardtitle ">
                            <div>
                              <img src={companyimg} alt="company"></img>
                              {user.first_name} {user.last_name}

                            </div>
                            <div className="action">
                              <Popconfirm
                                className="action"
                                title={t("are_you_sure_to_restore")}
                                okText={t("pop_ok")}
                                cancelText={t("pop_cancel")}
                                onConfirm={() => handleRestore(user.id)}
                              >
                                <DeleteOutlined />
                              </Popconfirm>
                            </div>
                          </div>
                          <Row gutter={16}>
                            <Col xs={12}>
                              <Form.Item>
                                <label>Employee ID</label>
                                <span className="value">{user.employe_id}</span>
                              </Form.Item>
                            </Col>
                            <Col xs={12}>
                              <Form.Item>
                                <label>Contact Number </label>
                                <span className="value">{user.phone}</span>
                              </Form.Item>
                            </Col>
                            <Col xs={12}>
                              <Form.Item>
                                <label>Role </label>
                                <span className="value">
                                  {user.groups
                                    .map((group) => group.role_name)
                                    .join(", ")}
                                </span>
                              </Form.Item>
                            </Col>
                            <Col xs={12}>
                              <Form.Item>
                                <label>Email </label>
                                <span className="value">{user.email}</span>
                              </Form.Item>
                            </Col>
                          </Row>
                        </div>
                      </Col>
                    ))}
                  </Row>
                </div>
              </Spin>
            </div>
          </Content>
  
    </>
  );
};

export default ArchivedSuperUserList;
